module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-1.47d36e06.jpg";